export default __webpack_public_path__ + "static/media/fb.cefd0597.jpg";